
import ready from './core/ready';

ready();



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/index.js